import React, { useEffect, useMemo, useState, useCallback, useContext } from "react";
import { Container, Row, Col, Button, ListGroup, ListGroupItem, Card, Form } from "react-bootstrap";
import { faHome, faClock, faConciergeBell, faCar, faBroom, faTshirt, faKey, faComment, faBackspace } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { currencyFormat, i18nValue, getLocale, priceWithoutTax } from '../functions';
import { serviceTypeIcon, getCDNImage } from '../globals';
import { formatDistanceToNow, format, parseISO } from 'date-fns'
import { es, enUS } from 'date-fns/locale'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faPen, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import Screen from '../components/Screen';
import { T } from "react-translator-component";
import { useParams } from 'react-router';
import { UserContext } from "../context/user";
import { CheckInContext } from "../context/checkin";
import { HotelContext } from "../context/hotel";
import { hotelShowsPriceWithoutTaxes } from "../components/CheckIn/hotelConditions";
import { confirm } from "react-confirm-box";
import Rate from "../components/Rate";
import Rated from "../components/Rated";
import { useReviews } from "../hooks/useReviews";
import UpSellingCard from "../components/UpSelling/UpSellingCard";
import { Edit } from "../components/Icons";
import { useRequests } from "../hooks/useRequests";

let icons = {
  'porter': faKey,
  'rooms_supplies': faHome,
  'tray_collection': faConciergeBell,
  'car_valet': faCar,
  'wakeup_call': faClock,
  'housekeeping': faBroom,
  'concierge': faConciergeBell,
  'pressing': faHome,
  'laundry': faTshirt,
  'general': faHome,
  'otro': faHome
};

const RequestDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: { id: hotelId }, currency } = useContext(HotelContext);
  const { data: { id: checkInId } } = useContext(CheckInContext);
  const { requests, getRequest, request, requestLoading, requestCancel, language, requestedCart, createPromiseUpsellComment, loadRequestedCart } = useContext(UserContext);
  const [item, setItem] = useState(null);
  const { doneRating } = useReviews();
  const [sendingComment, setSendingComment] = useState(false);
  const [editingComment, setEditingComment] = useState(false);
  const [comment, setComment] = useState('');
  const { addComment } = useRequests(hotelId, null, checkInId);
  const [dates, setDates] = useState([]);

  let hasTaxes = hotelShowsPriceWithoutTaxes(hotelId);
  const updatedAgo = useMemo(() => {
    if (!item || !item.updatedAt) return false;
    const _updatedDate = Date.parse(item.updatedAt);
    let _r = '-';
    try {
      _r = formatDistanceToNow(_updatedDate, { addSuffix: true, locale: language === 'es' ? es : enUS });
    } catch (e) {
      console.error(e);
    }
    return _r;
  }, [item, language]);

  const actualObservations = useMemo(() => {
    let _obs = [];
    if (!item) return _obs;
    if (item.status === 'observed' || item.status === 'in_progress') {
      item.evolutions && item.evolutions.forEach(ev => {
        if (ev.status === item.status) {
          _obs.push(ev);
        } else if (ev.status !== null) {
          _obs = [];
        }
      });
    }
    return _obs;
  }, [item]);




  const cart = useMemo(() => {
    if (!item) return null;
    if (!requestedCart) return null;
    return requestedCart.items;
  }, [item, requestedCart]);



  const showImages = useMemo(() => {
    let _showImages = false;
    if (cart && cart.length > 0) {
      _showImages = cart.reduce((res, i) => res || Boolean(i.menuItemDetails?.photo), false);
    }
    return _showImages;
  }, [cart]);


  const _cancelRequest = useCallback(() => {
    const confirmOptions = {
      labels: {
        confirmable: T('general.yes'),
        cancellable: T('general.no')
      },
      classNames: {
        container: "custom-confirm-box-container", // Clase CSS personalizada para el contenedor
        buttons: "custom-confirm-box-buttons", // Clase CSS personalizada para todos los botones
        confirmButton: "btn btn-success w-50", // Clase CSS personalizada para el botón de confirmar
        cancelButton: "btn btn-danger w-50" // Clase CSS personalizada para el botón de cancelar
      },
    };
    confirm(T('request.confirm-cancel'), confirmOptions).then(r => {
      if (r) {
        requestCancel(item.id);
      }
    });
  }, [item, requestCancel]);

  const _editRequest = () => {
    console.log('_editRequest', item);

    let auxRequestedCart = { ...requestedCart }
    auxRequestedCart.requestId = item.id;
    auxRequestedCart.observations = item.observations;

    loadRequestedCart(auxRequestedCart);

    navigate(`../../services/service_room_service?request=${item.id}`)
  }

  useEffect(() => {
    refresh();
  }, []);

  const refresh = async () => {
    // if (!item) return;
    // !item?.isPromise && getRequest(id);
    await getRequest(id);
  };

  useEffect(() => {
    const initialData = requests?.filter(i => i.id === id)[0];
    if (initialData?.id) {
      // setItem({ ...initialData });
      setComment(initialData.comment)
    }
    if (id === request?.id) {
      setItem(request);
    }

    if (request?.data?.extra != null) {
      // setDates(JSON.parse(JSON.parse(request?.data?.extra).values).find(v => v.dates != undefined)?.dates);
      try {
        const parsedExtra =
          typeof request.data.extra === "string"
            ? JSON.parse(request.data.extra)
            : request.data.extra;
        const _extra = (parsedExtra && typeof parsedExtra === "object") ? parsedExtra : null;
        if (_extra?.values) {
          const _values = typeof _extra.values === 'string' ? JSON.parse(_extra.values) : _extra.values;
          if (Array.isArray(_values) && _values.find(v => v.dates != null)) {
            setDates(_values.find(v => v.dates != null).dates);
          }
        }
      } catch (e) {
        console.warn("RequestDetail: extra inválido", e);
      }
    }
  }, [id, request, requests]);

  const lastMessages = useMemo(() => {
    if (!item || !item.evolutions || item.evolutions.length === 0) return [];
    if (item.status === 'done' || item.status === 'canceled') return item.evolutions;
    return item.evolutions.slice(-3);
  }, [item?.evolutions, item?.status]);

  if (!item || item.id !== id) {
    return <div class="loading d-flex h-100 align-items-center justify-content-center"><div className="spinner-border" role="status"></div></div>;
  }

  const onCommentSubmit = async (e) => {
    setSendingComment(true);
    console.log('18ago - item.isPromise', item.isPromise)
    if (item.isPromise) {
      await createPromiseUpsellComment(item.promiseKey, comment);
    } else {
      await addComment(id, comment)
    }
    setSendingComment(false);
    setEditingComment(false);
  };

  const renderCustomizations = (item) => {
    if (!item.customizations || item.customizations.length < 1 || Object.keys(item.item.preferences).length === 0) {
      return <></>
    }
    const showOptionLabel = (item.customizations.length > 1);    
    return (
      <div className="mt-2 mb-1">
        {
          item.customizations.map((item1, index) => {
            
            // Recorrer las claves y valores del objeto
            return Object.keys(item1).map((key, idx) => {
              // console.log(`  Clave: ${key}`);
              // console.log(`  Valor: ${item1[key]}`);

              const _label = item.item.preferences[key]?.titleI18n['en-US'];
              const _value = item.item.preferences[key]?.options[item1[key]]?.valueI18n['en-US'];

              // console.log(_label);
              // console.log(_value);
              
              return(
                <div key={`customization-${key}-${item1[key]}`} className="overflow-hidden mx-1 mb-1">
                  { ((idx== 0) && showOptionLabel) && (<div className="font-weight-bold mt-2">{T('request.option')}{` ${index + 1}:`}</div>) }                  
                  <div className="d-flex w-auto mt-1 pl-1 pr-0 py-0" style={{ background: "#dee2e6" }}>
                    <div className="font-size-sm bg-light px-2" style={{ width: "100%" }}>
                      <div className="text-muted mr-2">{_label}</div>
                      <div className="font-weight-bolder text-primary">{_value}</div>
                    </div>
                  </div>
                </div>
              )
            })

          })

        }
      </div>
    )    
  }

  return (
    <Screen
      section="request"
      title={T('request.detail-title')}
    >
      <div className="text-center">
        <div className="my-3">
          <div className="mb-2" style={{ display: 'inline-block', padding: 15, verticalAlign: 'text-top', background: '#FFF', borderRadius: '50%', border: '1px solid #EEE' }}>{serviceTypeIcon(item.type, 50)}</div>
          <h5 className="mb-3">{T(`services.type.${item.type}`)}</h5>
          <span className={`label label-lg label-light-${item.status} label-inline text-uppercase mb-2 d-inline-block`}>{T(`services.status.${item.status}`)}</span>
          {actualObservations && actualObservations.length > 0 && <p style={{ fontSize: "0.9rem" }} className="mb-0">
            {actualObservations.map(obs => {
              return (<div key={obs.id}>{obs.comment}</div>);
            })}
          </p>}
        </div>
      </div>
      {requestLoading && <div className="w-100 text-center mt-4"><div className="loading"><div className="spinner-border" role="status"></div></div></div>}

      {!requestLoading && item && item.type === "up_selling" &&
        <>
          {dates && dates.length > 0 && 
            <Card className="calendar-card">
              <Card.Header className="p-2 calendar-header">
                <div className="text-center mb-0" style={{ whiteSpace: "nowrap" }}>
                  {T('request.reserved-days')}
                </div>
             </Card.Header>
              <Card.Body>
                <Row className="d-flex justify-content-center">
                  {dates.map((date, idx) => { 
                    return <Col md={3} xs={2} className="available-date text-center" key={idx}>{format(parseISO(date), "dd MMM", { locale: getLocale(language) })}</Col>
                  })}
                </Row>
              </Card.Body>
            </Card>
          }
          <Row xs={1} md={2} className="g-4 cross-up-selling p-4">
            <UpSellingCard cup={item.data} path="request-detail" currency={currency} />
          </Row>

          {!requestLoading && item.data?.bookable && !dates && <div className="d-flex justify-content-center">
            <div className="text-success p-2">
              <div className="text-success text-center mb-0" style={{ whiteSpace: "nowrap" }}>
                {T('cups.booked')}
              </div>
              {item.data?.bookable?.day && item.data?.bookable?.hour && `${format(parseISO(item.data.bookable.day), "dd MMM yyyy", { locale: getLocale(language) })} - ${item.data.bookable.hour} hs - ${item.data?.bookable?.qty} ${T("cups.spots")}`}
            </div>
          </div>}
        </>
      }

      {!requestLoading && (
        <Row>
          <Col>
          {item?.deliveryPoint && <div style={{ background: '#FFF0A8', borderRadius: 8, textAlign: 'center', padding: '5px 15px', border: '1px solid #E8D36C' }}>
              <small>
                {T('request.delivery-point')}
                </small>
                <h5>{String(item?.deliveryPoint).toUpperCase()}</h5>
              </div>}

            {cart && cart?.length > 0 && (
              <ListGroup className="list-group-flush shadow my-3 general-text-sm">
                {cart.map((r, idx) => {
                  if (r.item) {
                    const { item } = r;
                    return (
                      <ListGroupItem key={`item-${idx}`} className="p-3">
                        <div className="d-flex">
                          
                          {(showImages) && (
                            <div style={{ flex: '0 0 50px' }} className="flex-shrink-0 mt-1 mr-2">
                              <div className="image-cover" style={{ height: 50, width: 50, backgroundImage: item.photo ? `url(${getCDNImage(item.photo)})` : "none" }}></div>
                            </div>
                          )}

                          <div style={{ flexGrow: 1 }} className="">
                            <div className="d-flex justify-content-between align-items-center">
                              <span>{r.qty}x</span>
                                 <div className="d-flex justify-content-between flex-column">
                                    <h4 className="text-primary font-size-sm mb-0">
                                      <div className="float-right font-weight-bold text-uppercase font-size-sm">{ currencyFormat(r.total, currency) }</div>
                                    </h4>
                                    {hasTaxes && (
                                        <div className="font-size-sm" style={{ fontSize: "0.68rem", fontStyle: "italic", color: "#5a5a5a" }}> {T("menu.price_without_taxes")}: { currencyFormat(priceWithoutTax(r.price), currency) }</div>
                                      )}
                                  </div>
                              </div>
                            <div className="mb-1 font-weight-bold text-uppercase font-size-sm">{i18nValue(item, 'name', language) || item.name}</div>
                            <p className="mb-0 text-muted" style={{ fontSize: 12, lineHeight: 1, maxHeight: 25, overflow: "hidden", textOverflow: "ellipsis" }}>{i18nValue(item, 'description', language) || item.description}</p>
                            {/* <p className="mb-0 font-size-sm">{T('general.price')}: {currency} {r.price}</p> */}
                            { renderCustomizations(r) }                            
                          </div>
                        </div>
                      </ListGroupItem>
                    );
                  } else {
                    return <ListGroupItem key={`item-${idx}`}>{r.qty}x{r.desc}</ListGroupItem>;
                  }
                })}
                <Card className="border-0">
                  <Card.Body className="font-size-sm">
                    {
                      request.observations && (
                        <div className="mb-1">
                          <div className="font-weight-bold">{T('request.observations')}</div>
                          <div>{request.observations}</div>
                        </div>
                      )
                    }
                    {/* <div className="d-flex justify-content-between">
                      <span className="font-weight-bold">{T("general.items.qty")}</span>
                      <span>{request.cart.qty}</span>
                    </div> */}
                    <div className="border-bottom my-2"></div>
                    <div className="d-flex justify-content-between font-size-md">
                      <span className="font-weight-bold">{T("general.total")}:</span>
                      <span className="font-weight-bold">{ currencyFormat(request.cart.total, currency) }</span>
                    </div>
                  </Card.Body>
                </Card>
              </ListGroup>
            )}

            {(!cart || cart.length === 0) && request?.observations && (
              <Card className="shadow-sm my-3">
                <Card.Body>
                  <div className="font-weight-bold mb-2">{T('request.observations') || 'Comentarios'}</div>
                  <div className="text-muted" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>{request.observations} </div>
                </Card.Body>
              </Card>
            )}

            {item.isPromise && !editingComment && (
              <Row className="mx-0">
                <Col >

                  {item.comment && <>
                    <Container className="card-generic border rounded pb-4" style={{ boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.3)' }}>

                      <div className="d-flex justify-content-between p-2 border-bottom" onClick={() => setEditingComment(true)}>
                        <div className="mt-2" >{T("request.observations")}</div>
                        <span>
                          {<Edit width={25} height={25} color="red" />}
                        </span>
                      </div>
                      <div className="mb-1 text-left font-italic p-3" style={{ color: '#777777', whiteSpace: 'pre-wrap', overflowWrap: 'break-word' }}>"{item.comment}"</div>
                    </Container>
                  </>
                  }
                  {!item.comment && <>
                    <div className="d-flex justify-content-center mt-3">
                      <button className="btn btn-secondary" onClick={() => setEditingComment(true)}>{T("request.create.comment")}</button>
                    </div>
                  </>}
                </Col>
              </Row>
            )}

            {false && lastMessages.length > 0 && (
              <Row>
                <Col>
                  <hr />
                  <div className="general-text text-center mb-3 mt-2">Historial de mensajes</div>
                  <Container className="card-generic shadow">
                    {item.evolutions.length > lastMessages.length && <p className="general-text-sm text-center text-muted">Hay {item.evolutions.length - 3} mensajes antiguos...</p>}
                    {lastMessages.map(obs => {
                      return (<div className={`d-flex general-text-sm my-1`} key={obs.id}>
                        <span style={{ width: 65 }}>{new Date(obs.createdAt).toLocaleDateString('es-AR')}</span>
                        <p style={{ flex: 1 }} className="general-text-sm text-left mb-0">{obs.comment}</p>
                      </div>);
                    })}
                    <div className='text-right'>
                      <Button
                        size={'sm'}
                        variant={'link'}
                        className="text-decoration-none mt-1"
                        onClick={() => { navigate(`messages`) }}
                      >
                        <FontAwesomeIcon icon={faPaperPlane} className="mr-1" /> Enviar Mensaje
                      </Button>
                    </div>
                  </Container>
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      )}

      <Row>
        <Col>
          {
            item.status === 'done' && (
              !doneRating && !request?.Review ? (
                <div className="text-center mt-4">
                  <Rate
                    key={`rate-${request?.id}`}
                    type="request"
                    service={item?.type}
                    hasReviews={request?.Review?.review}
                    serviceId={item?.id}
                    onRate={() => { refresh() }}
                  />
                </div>
              ) : (
                <div className="text-center mt-4">
                  <Rated
                    key={`rate-${request?.id}-r`}
                    hasRated={request?.Review}
                  />
                </div>
              )
            )
          }
        </Col>
      </Row>
      
      {
        updatedAgo && 
          <Row><Col><div className="text-center small mb-4">{updatedAgo}</div></Col></Row>
      }

      {
        !requestLoading && !item?.isPromise && (
          <div className="footer-container">

            { /* NO PENDING*/}
            { item.status != 'pending' && (
              <Col xs={12}>
                <Button
                  size={'lg'}
                  variant={'primary'}
                  type={'button'}
                  block={true}
                  onClick={() => { navigate(`messages`) }}
                >
                  <FontAwesomeIcon icon={faComment} className="mr-1" /> Chat
                </Button>
              </Col>
            )}

            { /* ROOM SERVICE - PENDING*/}
            { (item.type === "room_service" && item.status === 'pending') && (
              <Row>
                <Col xs={4} className="pr-1">
                  <Button
                    size={'lg'}
                    variant={'danger'}
                    type={'button'}
                    block={true}
                    onClick={() => { _cancelRequest() }}
                  >
                    <FontAwesomeIcon icon={faTimesCircle} className="mr-1" /> {T('general.cancel')}
                  </Button>
                </Col>
                <Col xs={3} className={"px-1"}>
                  <Button
                    size={'lg'}
                    variant={'primary'}
                    type={'button'}
                    block={true}
                    onClick={() => { navigate(`messages`) }}
                  >
                    <FontAwesomeIcon icon={faComment} className="mr-1" /> Chat
                  </Button>
                </Col>
                <Col xs={5} className="pl-1">
                  <Button
                    size={'lg'}
                    className={'cart-edit'}
                    type={'button'}
                    block={true}
                    onClick={() => { _editRequest() }}
                  >
                    <FontAwesomeIcon icon={faPen} className="mr-1" /> {T('general.edit')}
                  </Button>
                </Col>
              </Row>
            )}

            { /* NO ROOM SERVICE - PENDING*/}
            { (item.type != "room_service" && item.status === 'pending') && (
              <Row>
                <Col xs={6} className="pr-1">
                  <Button
                    size={'lg'}
                    variant={'danger'}
                    type={'button'}
                    block={true}
                    onClick={() => { _cancelRequest() }}
                  >
                    <FontAwesomeIcon icon={faTimesCircle} className="mr-1" /> {T('general.cancel')}
                  </Button>
                </Col>
                <Col xs={6} className={"pl-1"}>
                  <Button
                    size={'lg'}
                    variant={'primary'}
                    type={'button'}
                    block={true}
                    onClick={() => { navigate(`messages`) }}
                  >
                    <FontAwesomeIcon icon={faComment} className="mr-1" /> Chat
                  </Button>
                </Col>
              </Row>
            )}
            
          </div>
        )
      }
      {
        !requestLoading && item?.isPromise && editingComment && (
          <div className="footer-container">
            {!sendingComment && <>
              <Form.Control
                type={"textarea"}
                value={comment}
                placeholder={`${T("request.generic.observation")}...`}
                maxLength={200}
                onChange={e => setComment(e.target.value)}
                as="textarea"
                style={{
                  fontSize: "0.75rem",
                  resize: "none",
                  boxShadow: '0px 10px 20px rgba(204, 204, 204, 1)',
                  minHeight: 120,
                  marginBottom: 25,
                  whiteSpace: 'pre-wrap'
                }}
              />
              {/* {errors.observations && (
              <Form.Control.Feedback type="invalid">
                {T(errors.observations)}
              </Form.Control.Feedback>
            )} */}
            </>}
            {sendingComment && <div class="loading d-flex h-100 align-items-center justify-content-center"><div className="spinner-border" role="status"></div></div>}
            <Row>
              <Col xs={6} className="pl-1">
                {!sendingComment && <Button
                  size={'lg'}
                  variant={'danger'}
                  type={'button'}
                  block={true}
                  onClick={() => setEditingComment(false)}
                >
                  <FontAwesomeIcon icon={faBackspace} className="mr-1" /> {T("general.cancel")}
                </Button>}
              </Col>


              <Col xs={6} className="pl-1">
                {!sendingComment && <Button
                  size={'lg'}
                  variant={'success'}
                  type={'button'}
                  block={true}
                  onClick={() => onCommentSubmit()}
                >
                  <FontAwesomeIcon icon={faComment} className="mr-1" /> {T("general.send_comment")}
                </Button>}

              </Col>
            </Row>
          </div>
        )
      }
      
    </Screen>
  );
}

export default RequestDetail;
